import React from "react";
import {
  TimelineContent,
  TimelineMetaList,
  TimelineMetaRow,
  TimelineNewBadge,
  TimelineSection,
  TimelineSectionTitle,
  TimelineTagList,
  TimelineTagPill,
  TimelineTitle,
  TimelineTitleRow,
} from "../TimelineLayout";

const TagSection = ({ title, tags }) => {
  if (!tags || tags.length === 0) {
    return null
  }

  return (
    <TimelineSection>
      <TimelineSectionTitle>{title}</TimelineSectionTitle>
      <TimelineTagList>
        {tags.map((mortgageTag) => (
          <TimelineTagPill key={mortgageTag.label}>{mortgageTag.label}</TimelineTagPill>
        ))}
      </TimelineTagList>
    </TimelineSection>
  )
}

const UploadSuccessful = ({milestone}) => (
  <TimelineContent>
    <TimelineTitleRow>
      <TimelineTitle>{milestone.milestone}</TimelineTitle>
      {milestone.notify && <TimelineNewBadge>new</TimelineNewBadge>}
    </TimelineTitleRow>
    <TimelineMetaList>
      <TimelineMetaRow>
        <span className="timeline-meta-label">upload by:</span>
        <span className="timeline-meta-value">{milestone.contributor}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">date:</span>
        <span className="timeline-meta-value">{milestone.date}</span>
      </TimelineMetaRow>
      {milestone.milestone !== 'File Upload' &&
        <TimelineMetaRow>
          <span className="timeline-meta-label">details:</span>
          <span className="timeline-meta-value">{milestone.details}</span>
        </TimelineMetaRow>
      }
    </TimelineMetaList>
    <TagSection
      title={milestone.newLeadTags?.length > 1 ? "New Investigation Tags" : "New Investigation Tag"}
      tags={milestone.newLeadTags}
    />
    <TagSection
      title={milestone.newMortgageTags?.length > 1 ? "New Mortgage Tags" : "New Mortgage Tag"}
      tags={milestone.newMortgageTags}
    />
  </TimelineContent>
)

export default UploadSuccessful
